

// Import specific Bootstrap components for modular use in the project.
import Offcanvas from 'bootstrap/js/dist/offcanvas';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";

import lazySizes from 'lazysizes';
import { initNavigation } from './modules/Navigation';
import { initFooter } from './sections/footer';
import { initLoader } from './modules/Loader';
import { initLanguageSwitcher } from './modules/LanguageSwitcher';

gsap.registerPlugin(ScrollTrigger,ScrollSmoother);
let scroller='';

function initLayout(smoothScroll=true){
	scrollToTop();
    initNavigation();
    initFooter();
    updateExternalLinks()
    // initLoader();
    initLanguageSwitcher();

    window.addEventListener('wovnApiReady', updateWovnTexts);
    window.addEventListener('wovnLangChanged', updateWovnTexts);

    if(smoothScroll){
        initScrollSmoother() 
    }
}

export function initScrollSmoother() {
    if (ScrollSmoother.get()) {
        ScrollSmoother.get().kill();
    }
    if (ScrollTrigger.isTouch !== 1 && window.innerWidth > 1200) {
        scroller = ScrollSmoother.create({
            smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
            effects: true, // looks for data-speed and data-lag attributes on elements
        });
    }

    return scroller
}

function scrollToTop(){
    const scrollToTopBtn = document.querySelector('.scroll-to-top');
    window.addEventListener('scroll', () => {
        if (window.scrollY >= 500) {
            scrollToTopBtn.classList.add('show');
        } else {
            scrollToTopBtn.classList.remove('show');
        }
    });

    let floatingButtonScrollTopElm=document.querySelector('.scroll-to-top');
    if(floatingButtonScrollTopElm){
        floatingButtonScrollTopElm.addEventListener('click', (event)=>{
            event.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        })
    }
}

function updateExternalLinks() {
    document.querySelectorAll('a').forEach(link => {
        if (externalLink(link)) {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');

            link.insertAdjacentHTML('beforeend', `
                <svg class="external-link-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.5 6H5.25C4.65326 6 4.08097 6.23705 3.65901 6.65901C3.23705 7.08097 3 7.65326 3 8.25V18.75C3 19.3467 3.23705 19.919 3.65901 20.341C4.08097 20.7629 4.65326 21 5.25 21H15.75C16.3467 21 16.919 20.7629 17.341 20.341C17.7629 19.919 18 19.3467 18 18.75V10.5M7.5 16.5L21 3M21 3H15.75M21 3V8.25" 
                        stroke="currentColor" stroke-width="1.5" 
                        stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            `);
        }
    });
}

function externalLink(link) {
    const currentHostname = window.location.hostname;
    const regex = new RegExp(`^https?://${currentHostname}/`);
    return !regex.test(link.href);
}

function updateWovnTexts() {
    const currentLang = WOVN.io.getCurrentLang();
    const langCode = currentLang.code.toUpperCase();
    console.log(langCode)
    // Select all elements with .wovn-current-text
    document.querySelectorAll('.wovn-current-text').forEach((el) => {
        el.textContent = langCode;
    });
}


export { initLayout };
